module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_7042.bd3a19e6.png";